/**
 * Focused left-menu keyword inputs must not run density sync.
 * Writing the draft into allKeywords on every keystroke retriggers the
 * article watcher, which used to $set(allKeywords) in a loop.
 */
let activeEdits = 0;

export function beginKeywordDensityEdit(): void {
    activeEdits += 1;
}

export function endKeywordDensityEdit(): void {
    activeEdits = Math.max(0, activeEdits - 1);
}

export function isKeywordDensityEditing(): boolean {
    return activeEdits > 0;
}

/** Test-only. */
export function resetKeywordDensityEditForTests(): void {
    activeEdits = 0;
}
